import React, { useRef, useEffect, useState } from 'react'

import { useField } from '@unform/core'
import classNames from 'classnames'

import { Input } from '../../input'
import { Componente, Erro } from './styles'
import { InputUnformProps } from './tipos'

export const InputUnform: React.FC<
  React.InputHTMLAttributes<HTMLInputElement> & InputUnformProps
> = ({
  name,
  label,
  ladoIcone,
  semMargemAbaixo,
  className,
  sucesso,
  mascara,
  bloquearCaracteresEspeciais,
  naoDeveLimpar,
  esconder,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [valor, definirValor] = useState('')

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError
  } = useField(name || '')

  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null) {
      definirValor(String(defaultValue))
    }
  }, [defaultValue])

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue() {
        return inputRef.current?.value || ''
      },
      setValue(ref: any, value: string) {
        if (value !== undefined && value !== null) {
          const stringValue = String(value)
          definirValor(stringValue)
          if (ref) {
            ref.value = stringValue
          }
        } else {
          definirValor('')
          if (ref) {
            ref.value = ''
          }
        }
      },
      clearValue() {
        definirValor('')
        if (inputRef.current) {
          inputRef.current.value = ''
        }
      }
    })
  }, [fieldName, registerField])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    definirValor(e.target.value)
    if (rest.onChange) {
      rest.onChange(e)
    }
  }

  // Quando a tela passa `value` por props, ele tem precedência sobre o estado
  // interno: campos controlados de fora (em geral `disabled`, sem digitação)
  // não têm como alimentar `valor` e ficariam sempre vazios.
  const valorExibido = rest.value !== undefined ? String(rest.value) : valor

  return (
    <Componente
      theme={{
        ComErro: !!error
      }}
      className={classNames(className, {
        semMargemAbaixo
      })}
      esconder={esconder}
    >
      <Input
        {...rest}
        mascara={mascara}
        name={name}
        value={valorExibido}
        ref={inputRef}
        erro={!!error}
        sucesso={sucesso}
        className={classNames({
          error
        })}
        label={label}
        ladoIcone={ladoIcone}
        onChange={handleChange}
        onKeyPress={() => {
          !naoDeveLimpar && clearError()
        }}
        bloquearCaracteresEspeciais={bloquearCaracteresEspeciais}
      />
      <Erro id={`erro-${rest.id}`} sucesso={sucesso}>
        {error}
      </Erro>
    </Componente>
  )
}
